import assign from 'lodash/assign';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

import ListingConversion from 'app/shared/model/ListingConversion';

const initState = () => new ListingConversion();

const propertyConversion = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.UPDATE_PROPERTIES_CONVERSION:
            return assign({}, state, payload);
        default:
            return state;
    }
};

export default propertyConversion;
